import { Component, AfterViewInit, OnInit } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import axios from 'axios';
import { Authenticationservice } from '../../services/authentication.service';
import { BrdsqlService } from '../../services/brdsql.service';
import * as $ from 'jquery';
import 'datatables.net';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-print-farmers',
  templateUrl: './print-farmers.component.html',
  styleUrls: ['./print-farmers.component.css']
})
export class PrintFarmersComponent {
  userdata: any;
  dataTable: any;

  constructor(private auth: Authenticationservice, private spinner: NgxSpinnerService, private brdsql: BrdsqlService, private http: HttpClient) {
    this.userdata = this.auth.Authention();
    this.supzone = brdsql.sumZonne;
  }
  supzone = []

  ngOnInit(): void {
  }
  ngAfterViewInit(): void {
    this.loadDataTable();
  }

  loadDataTable(): void {
    let url = 'https://asia-southeast2-brr-farmluck.cloudfunctions.net/function-3/datatable_w';// เปลี่ยนเป็น URL ของ Cloud Function
    let dataTable = {
      table: `[dbo].[v_follow_work_fm_6869]`
      , col_like: 'fmcode,fmname'
    }
    let self = this; // ใช้ self เพื่อให้สามารถเรียก method ภายใน class ได้
    let table = $('#datatable').DataTable({
      processing: true,
      serverSide: true,
      paging: true, // ✅ เปิดใช้งาน Pagination
      searching: true, // ✅ เปิดใช้งาน Search
      ordering: true, // ✅ เปิดใช้งาน Sorting

      //lengthMenu: [5, 10, 25, 50], // ✅ ตั้งค่าจำนวนรายการต่อหน้า
      ajax: (data, callback) => {
        $('#loadingIndicator').show(); // แสดงตัวโหลดก่อนเรียก API
        const params = {
          table: dataTable.table,
          col_like: dataTable.col_like,
          start: (data as any).start,
          length: (data as any).length,
          search: (data as any).search.value,
          orderColumn: (data as any).columns[(data as any).order[0].column].data,
          orderDir: (data as any).order[0].dir,
          draw: (data as any).draw
        };

        this.http.get(url, { params }).subscribe((resp: any) => {
          callback({
            recordsTotal: resp.recordsTotal,
            recordsFiltered: resp.recordsFiltered,
            data: resp.data
          });
          $('#loadingIndicator').hide(); // ซ่อนตัวโหลดหลังจากโหลดเสร็จ
        }, () => {
          $('#loadingIndicator').hide(); // ซ่อนตัวโหลดในกรณีเกิดข้อผิดพลาด
        });
      },
      columns: [
        { data: 'fmcode', title: 'โควตา' },
        { data: 'fmname', title: 'ชื่อชาวไร่', className: 'text-left' },
        { data: 'supzone', title: 'โซน' },
        { data: 'supcode', title: 'นสส' },
        {
          data: 'landvalue', title: 'พื้นที่',
          render: (data: any) => { return this.formatNumber(data, 2, 2) }, className: 'text-right'
        },
        {
          data: 'formula_15_5_30', title: '15-5-30',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        {
          data: 'formula_20_5_28', title: '20-5-28',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        {
          data: 'Organic_powder_bulk', title: 'เทกอง',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        {
          data: 'Organic_granular', title: 'อินทรีย์เม็ด',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        {
          data: 'Organic_powder25kg', title: 'อินทรีย์ผง',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        {
          data: 'formula_6_3_3', title: '6-3-3',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        {
          data: 'dolomite', title: 'โดโลไมต์',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        {
          data: 'Planting_cost', title: 'ค่าปลูก',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        {
          data: 'Rent', title: 'ค่าเช่า',
          render: (data: any) => { return this.formatNumber(data, 0, 0) }, className: 'text-right'
        },
        /*{
          data: null, title: 'Actions',
          orderable: false,
          render: function (data: any, type: any, row: any) {
            return `<button class="btn btn-primary btn-sm action-btn" data-row='${JSON.stringify(row)}'>เลือก</button>`;
          }
        }*/
      ]
    });
    // เพิ่ม Event ตรวจจับการพิมพ์ในช่อง Search
    /*$('#datatable_filter input')
    .off()
    .on('keyup', function () {
      let searchText: string = String($(this).val()); // บังคับเป็น string
      if (searchText.length > 2) {
        self.dataTable.search(searchText).draw(); // ค้นหาเมื่อมากกว่า 2 ตัวอักษร
      } else {
        self.dataTable.search('').draw(); // รีเซ็ตผลลัพธ์ถ้าพิมพ์น้อยกว่า 2 ตัวอักษร
      }
    });*/

    // Handle Click Event on Button
    $('#datatable tbody').on('click', '.action-btn', function () {
      let rowData = $(this).attr('data-row');
      let parsedData = JSON.parse(rowData);
      self.onButtonClick(parsedData);
    });
  }

  // Method ที่ใช้รับค่าจากปุ่ม
  onButtonClick(rowData: any) {
    console.log('ข้อมูลที่ถูกเลือก:', rowData);
    // ทำงานเพิ่มเติมที่นี่ เช่น เรียก API หรือไปยังหน้าอื่น
  }

  formatNumber(value: number, a: number, b: number): string {
    return new Intl.NumberFormat('en-US', { minimumFractionDigits: a, maximumFractionDigits: b }).format(value);
  }



  yearN = { "yearTh": "6768", "yearlf": "67", "yearCr": "2425", "yearDesc": "ปี 2567/2568", "state": 0 };

  printPage() {
    window.print();

  }

  calPercent(total: number, part: number): number {
    if (total == 0 || part == 0) {
      //console.error('Total value cannot be zero');
      return 0;
    }
    let num: number = parseFloat(((part / total) * 100).toFixed(2));
    return num;
  }

}
